import React, { useEffect, useState } from 'react';
import './GuildWarInstructions.css';

const GID = '5be953486a32da5b2aff5a7b8f8833d1';
const CACHE_API_URL = `https://rangers-api-3mfw.onrender.com/api/guild-war-ranking-nihon/history/cache/${GID}`;
const LIVE_API_URL = `https://rangers-api-3mfw.onrender.com/api/guild-war-ranking-nihon/history/${GID}`;

function sumBy(arr, key) {
  return arr.reduce((acc, cur) => acc + (cur[key] || 0), 0);
}

const thLabels = [
  { key: 'name', label: 'Name' },
  { key: 'winCount', label: 'Win' },
  { key: 'loseCount', label: 'Lose' },
  { key: 'winRate', label: 'Rate' },
  { key: 'bonusPoint', label: 'Point' },
];

export default function GuildWarRankingNihon() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [sortKey, setSortKey] = useState('winRate');
  const [sortOrder, setSortOrder] = useState('desc');
  const [activeTab, setActiveTab] = useState('total'); // 'total' or 'season'

  // 初回はキャッシュAPI
  useEffect(() => {
    fetch(CACHE_API_URL)
      .then(res => res.json())
      .then(data => {
        setHistory(data.history || []);
        setLoading(false);
        if (data.history && data.history.length > 0) {
          setSelectedSeason(data.history[0].season); // 最新シーズンを初期選択
        }
      });
  }, []);

  // 最新データ取得
  const fetchLive = () => {
    setLoading(true);
    fetch(LIVE_API_URL)
      .then(res => res.json())
      .then(data => {
        setHistory(data.history || []);
        setLoading(false);
        if (data.history && data.history.length > 0) {
          setSelectedSeason(data.history[0].season);
        }
      });
  };

  if (loading) return <div>Loading...</div>;
  if (!history.length) return (
    <>
      <div>No data</div>
      <button className="fetch-button" style={{ margin: 0 }} onClick={fetchLive}>
        Get Latest Data
      </button>
    </>
  );
  // メンバーごとの合計
  const memberMap = {};
  history.forEach(season => {
    season.members.forEach(m => {
      if (!memberMap[m.name]) {
        memberMap[m.name] = { name: m.name, winCount: 0, loseCount: 0, bonusPoint: 0 };
      }
      memberMap[m.name].winCount += m.winCount || 0;
      memberMap[m.name].loseCount += m.loseCount || 0;
      memberMap[m.name].bonusPoint += m.bonusPoint || 0;
    });
  });
  let memberTotals = Object.values(memberMap).map(m => ({
    ...m,
    winRate: (m.winCount + m.loseCount) > 0 ? (m.winCount / (m.winCount + m.loseCount)) * 100 : 0
  }));

  // ソート
  memberTotals.sort((a, b) => {
    let aVal = a[sortKey];
    let bVal = b[sortKey];
    if (sortKey === 'name') {
      aVal = aVal || '';
      bVal = bVal || '';
      return sortOrder === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    } else {
      return sortOrder === 'asc' ? aVal - bVal : bVal - aVal;
    }
  });

  // 全体合計
  const totalWin = sumBy(memberTotals, 'winCount');
  const totalLose = sumBy(memberTotals, 'loseCount');
  const totalBonus = sumBy(memberTotals, 'bonusPoint');

  // セレクトボックス用
  const seasonOptions = history.map(season => season.season);

  // 選択中シーズンのデータ
  const selectedSeasonData = history.find(season => season.season === selectedSeason);
  let seasonMembers = (selectedSeasonData ? selectedSeasonData.members : []).map(m => ({
    ...m,
    winRate: (m.winCount + m.loseCount) > 0 ? (m.winCount / (m.winCount + m.loseCount)) * 100 : 0
  }));

  // シーズン表のソート
  seasonMembers.sort((a, b) => {
    let aVal = a[sortKey];
    let bVal = b[sortKey];
    if (sortKey === 'name') {
      aVal = aVal || '';
      bVal = bVal || '';
      return sortOrder === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    } else {
      return sortOrder === 'asc' ? aVal - bVal : bVal - aVal;
    }
  });

  // ソートハンドラ
  const handleSort = key => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder(key === 'name' ? 'asc' : 'desc');
    }
  };

  return (
    <div className="guild-war-instructions">
      <style>{`
        .responsive-table {
          border: 2px solid #b0b0b0;
        }
        .responsive-table th, .responsive-table td {
          border: 1px solid #b0b0b0;
        }
      `}</style>
      <div className="tab-navigation">
        <button
          className={`tab-button${activeTab === 'total' ? ' active' : ''}`}
          onClick={() => setActiveTab('total')}
        >
          Total 10 Seasons
        </button>
        <button
          className={`tab-button${activeTab === 'season' ? ' active' : ''}`}
          onClick={() => setActiveTab('season')}
        >
          Season by Season
        </button>
      </div>

      {activeTab === 'total' && (
        <div>
          <h2 style={{ marginTop: 0 }}>Guild War Total 10 Seasons</h2>
          <ul>
            <li>Win: {totalWin}</li>
            <li>Lose: {totalLose}</li>
            <li>Point: {totalBonus}</li>
          </ul>
          <table className="responsive-table">
            <thead>
              <tr>
                <th></th>
                {thLabels.map(th => (
                  <th key={th.key} onClick={() => handleSort(th.key)}>
                    {th.label}
                    {sortKey === th.key ? (sortOrder === 'asc' ? ' ▲' : ' ▼') : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {memberTotals.map((m, idx) => (
                <tr key={m.name}>
                  <td>{idx + 1}</td>
                  <td>{m.name}</td>
                  <td>{m.winCount}</td>
                  <td>{m.loseCount}</td>
                  <td>{m.winRate.toFixed(2)}%</td>
                  <td>{m.bonusPoint}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="fetch-button" style={{ margin: 0 }} onClick={fetchLive}>
            最新データ取得
          </button>
        </div>
      )}

      {activeTab === 'season' && (
        <div>
          <h2 style={{ marginTop: 0 }}>Season by Season</h2>
          <label style={{ display: 'block', marginBottom: 16 }}>
            Season Select:
            <select
              className="group-select"
              value={selectedSeason || ''}
              onChange={e => setSelectedSeason(Number(e.target.value))}
              style={{ marginLeft: 8 }}
            >
              {seasonOptions.map(season => (
                <option key={season} value={season}>{season}</option>
              ))}
            </select>
          </label>
          {selectedSeasonData ? (
            <>
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th></th>
                    {thLabels.map(th => (
                      <th key={th.key} onClick={() => handleSort(th.key)}>
                        {th.label}
                        {sortKey === th.key ? (sortOrder === 'asc' ? ' ▲' : ' ▼') : ''}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {seasonMembers.map((m, idx) => (
                    <tr key={m.name}>
                      <td>{idx + 1}</td>
                      <td>{m.name}</td>
                      <td>{m.winCount}</td>
                      <td>{m.loseCount}</td>
                      <td>{m.winRate.toFixed(2)}%</td>
                      <td>{m.bonusPoint}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="fetch-button" style={{ margin: 0 }} onClick={fetchLive}>
                Get Latest Data
              </button>
            </>
          ) : (
            <>
              <div>No data</div>
              <button className="fetch-button" style={{ margin: 0 }} onClick={fetchLive}>
                Get Latest Data
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
